import React, { useEffect, useState } from "react";
import { Button, HttpError, Title, useLogout } from 'react-admin';
import { apiUrl } from '../global';
import { useNotify, useRefresh, useRedirect, useAuthProvider } from 'react-admin';
import { httpClient } from '../admin/dataProvider';
import { Card, CardContent, Chip, Dialog, Stack, TextField, Button as CButton, ListItemText, Pagination, Badge } from "@mui/material";
import { useMutation, useQuery } from "react-query";
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import AddIcon from '@mui/icons-material/Add';
import qs from "qs";
import SortsDashboard_sub from "./SortsDashboard_sub";

const SortsDashboard = () => {
    const notify = useNotify();
    const [ProductCustomSortsCount, SetProductCustomSortsCount] = useState<any>(null);

    const { data, isLoading, isError, error, isSuccess, refetch } = useQuery(['getSorts'], () =>
        httpClient(`${apiUrl}/Admin/CMSProduct/GetSorts`, {
            method: 'POST',
            contentType: 'application/x-www-form-urlencoded',
            body: qs.stringify({})
        }).then(({ json }) => {
            if (json.Code == 1) return json.Result || 'null';
        }), {}
    )

    const _get_ProductCustomSortsCount = (sortId: number) => {
        if (ProductCustomSortsCount != null) {
            const item = ProductCustomSortsCount.find((t: any) => t.sortId == sortId);
            if (item != null) return item.customProCount;
        }
        return 0;
    }

    return (
        <Card sx={{ p: 2 }}>
            <GetProductCustomSortsCount SetProductCustomSortsCount={SetProductCustomSortsCount} />
            <Stack>分类列表（自定义产品排序）</Stack>
            <CardContent>
                {isLoading && <div>loading</div>}
                {isSuccess && <Stack alignItems={'flex-start'} spacing={4}>
                    {data.map((item: any) => {
                        const { id, PC_Name, subList }: any = item;
                        return <Stack alignItems={'flex-start'} sx={{ gap: 1 }}>
                            <CustomSortList _ProductCustomSortsCount={_get_ProductCustomSortsCount(id)} topSort={true} sortId={id} PC_Name={PC_Name} />
                            <Stack direction={'row'} sx={{ pl: 2, gap: 1 }} flexWrap={'wrap'}>
                                {subList.map((item2: any) => {
                                    const { id: id2, PC_Name: PC_Name2 }: any = item2;
                                    return <CustomSortList _ProductCustomSortsCount={_get_ProductCustomSortsCount(id2)} sortId={id2} PC_Name={PC_Name2} />
                                })}
                            </Stack>
                        </Stack>
                    })}
                </Stack>
                }
            </CardContent>
        </Card>
    );
};

const GetProductCustomSortsCount = ({ SetProductCustomSortsCount }: any) => {
    const { data, isLoading, isError, error, isSuccess, refetch } = useQuery(['GetProductCustomSortsCount'], () =>
        httpClient(`${apiUrl}/Admin/CMSProduct/GetProductCustomSortsCount`, {
            method: 'POST',
            contentType: 'application/x-www-form-urlencoded',
            body: qs.stringify({})
        }).then(({ json }) => {
            if (json.Code == 1) {
                SetProductCustomSortsCount(json.Result);
                return json.Result || 'null';
            }
        }), {}
    )
    return null;
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<unknown>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const CustomSortList = ({ _ProductCustomSortsCount = 0, topSort = false, sortId, PC_Name }: any) => {
    const [cData, SetcData] = React.useState<any>([]);
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
        refetch();
    };

    const handleClose = () => {
        setOpen(false);
    };

    const { data, isLoading, isError, error, isSuccess, refetch } = useQuery(['GetProductCustomSorts', sortId], () =>
        httpClient(`${apiUrl}/Admin/CMSProduct/GetProductCustomSorts`, {
            method: 'POST',
            contentType: 'application/x-www-form-urlencoded',
            body: qs.stringify({ sortId: sortId })
        }).then(({ json }) => {
            if (json.Code == 1) {
                SetcData(json.Result);
                return json.Result || 'null';
            }
        }), { enabled: false }
    )
    // console.log('data', data);

    const { mutate: _saveProductCustomSorts, isLoading: _saveProductCustomSorts_isLoading } = useMutation((data: any) =>
        httpClient(`${apiUrl}/Admin/CMSProduct/SetProductCustomSorts`, {
            method: 'POST', contentType: 'application/x-www-form-urlencoded',
            body: qs.stringify(data)
        }).then(({ json }) => {
            if (json.Code == 1) {
                alert(json.Message);
                // setOpen(false);
            } else { throw new HttpError(`${json.Message}`, 500); }
        }), {
        onSuccess: () => { },
        onError: (err) => { alert(`${err}`) }
    })
    const save = () => {
        const pIds = cData.map(({ id }: any) => id);
        _saveProductCustomSorts({ sortId: sortId, pIds });
    }

    const addPro = (data: any) => {
        console.log(data);
        const _cData = [...cData];
        if (_cData.findIndex(t => t.id == data.id) >= 0)
            alert('已经存在该记录')
        else if (_cData.length >= 200)
            alert('最多只能自定义200个产品排序');
        else {
            _cData.push(data);
            SetcData(_cData);
        }
    }

    return (
        <>
            <Badge color="secondary" badgeContent={_ProductCustomSortsCount}><Chip label={PC_Name} onClick={handleClickOpen} /></Badge>
            <Dialog fullScreen open={open}
            // slots={{ transition: Transition, }}
            // onClose={handleClose}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            设置 {PC_Name} 分类产品排序
                        </Typography>
                        <CButton disabled={_saveProductCustomSorts_isLoading} color="inherit" onClick={save}>
                            {_saveProductCustomSorts_isLoading ? '保存中...' : '保存'}
                        </CButton>
                    </Toolbar>
                </AppBar>
                <Stack sx={{ flex: 1, p: 1 }} direction={'row'} spacing={1}>
                    <Stack sx={{ flex: 3, backgroundColor: '#eee', p: 1 }} direction={'row'} alignItems={'flex-start'} alignContent={'flex-start'} flexWrap={'wrap'}>
                        {isLoading && <div>loading</div>}
                        {isSuccess && cData.length == 0 && <div>没有任何内容</div>}

                        {/* {isSuccess && cData.map(({ id, P_Images, P_BrandNameEN, P_BrandName, P_CommonTitleEN, P_CommonTitle, ProductCountry_id, ProductCompany_id, P_ProContent, P_ProNum, P_SmallUnit, P_IsShelves, P_Reservation, P_IsHFGM, ISHuiZhen, Cate2 }: any, _ind: number) => <Stack direction={'row'} alignItems={'center'} sx={{ backgroundColor: '#FFF', mr: 1, mb: 1, p: 1, border: '1px solid #CCC', width: '31%', gap: 1 }}>
                            <Stack sx={{ fontSize: 14, position: 'relative' }}>
                                <Chip size='small' color="primary" sx={{ position: 'absolute', left: 0, bottom: 0 }} label={_ind + 1} />
                                <div style={{ position: 'absolute', left: 0, top: 0 }}>{id}</div>
                                <img style={{ width: 80, height: 80 }} src={P_Images[0].src} />
                            </Stack>
                            <Stack sx={{ fontSize: 14, flex: 1 }}>
                                <div>{P_BrandNameEN}</div>
                                <div>{P_BrandName}</div>
                                <div>{P_CommonTitleEN}</div>
                                <div>{P_CommonTitle}</div>
                            </Stack>
                            <Stack sx={{ fontSize: 14 }} alignItems={'flex-end'}>
                                <div>{P_ProContent}</div>
                                <div>{P_ProNum}/{P_SmallUnit}</div>
                            </Stack>
                            <Stack>
                                <CButton onClick={() => { }}><CloseIcon /></CButton>
                            </Stack>
                        </Stack>)} */}
                        <SortsDashboard_sub items={cData} setItems={SetcData} />

                    </Stack>
                    {open && isSuccess && <CustomSortList_Sub cData={data} sortId={topSort ? sortId : null} sort2Id={!topSort ? sortId : null} addPro={addPro} />}
                </Stack>
            </Dialog>
        </>
    )
}
const CustomSortList_Sub = ({ cData, sortId = null, sort2Id = null, addPro }: any) => {
    const [keyWords, setKeyWords] = useState('');
    const [page, setPage] = useState(0);
    const pagesize = 10;

    const hasKey = (keyWords ?? '').trim().length > 0;
    const qsObj = { GroupByAddMinNum: true, _page: page, _pagesize: pagesize, Key: keyWords, Status: 'sj', Cate1Id: hasKey ? null : sortId, Cate2Id: hasKey ? null : sort2Id, ExcludeIds: cData.map(({ id }: any) => id) };
    const { data, isLoading, isError, error, isSuccess, refetch } = useQuery(['GetList', sort2Id, page], () =>
        httpClient(`${apiUrl}/Admin/CMSProduct/GetList?${qs.stringify(qsObj)}`, {
            method: 'GET',
        }).then(({ json }) => {
            if (json.Code == 1) return json.Result || 'null';
        }), { enabled: true }
    )
    const search = (e: any) => {
        if (page != 0) setPage(0);
        else refetch();
        e.preventDefault();
    }
    return (
        <Stack sx={{ flex: 1, height: 1, width: 1 }}>
            <Stack>
                <form onSubmit={search}>
                    <Stack direction={'row'} alignItems={'baseline'} sx={{ gap: 1 }}>
                        <TextField sx={{ flex: 1 }} label="关键词" variant="outlined" onChange={(e) => setKeyWords(e.target.value)} />
                        <CButton type='submit' variant="outlined">搜索</CButton>
                    </Stack>
                </form>
            </Stack>
            <Stack sx={{ my: 1, flexGrow: 1, height: 0, overflow: 'auto' }}>
                {isLoading && <div>loading</div>}
                {
                    isSuccess && data && data.data.map((data: any) => {
                        const { id, Cate2, P_Images, P_BrandNameEN, P_BrandName, P_CommonTitleEN, P_CommonTitle, P_ProContent, P_ProNum, P_SmallUnit, P_LimitNumMin, ProductCountry_id, ProductCompany_id, P_IsShelves, P_Reservation, P_IsHFGM, ISHuiZhen, P_TransportType, P_Price } = data;
                        const imgSrc = (P_Images != null && P_Images.length > 0) ? P_Images[0].src : '#';
                        return (
                            <Stack key={id} direction={'row'} alignItems={'center'} sx={{ py: 1, gap: 1, borderBottom: '1px solid #DDD' }}>
                                <Stack sx={{ fontSize: 12, position: 'relative' }}>
                                    <div style={{ position: 'absolute', left: 0, top: 0 }}>{id}</div>
                                    <img style={{ width: 80, height: 80 }} src={imgSrc} />
                                </Stack>
                                <Stack sx={{ fontSize: 12, flex: 1 }}>
                                    <Stack direction={'row'} sx={{ gap: 1 }} alignItems={'center'}>
                                        <div>{((P_LimitNumMin ?? 0) > 1) && <span style={{ color: 'red' }}>起购{P_LimitNumMin ?? 0}</span>}{P_BrandNameEN}</div>
                                        <ProTags price={P_Price} P_IsShelves={P_IsShelves} P_TransportType={P_TransportType} hzgm={ISHuiZhen} hfgm={P_IsHFGM} reservation={P_Reservation} />
                                    </Stack>
                                    <div>{P_BrandName}</div>
                                    {/* <div>{P_CommonTitleEN}</div> */}
                                    <div>{P_CommonTitle}</div>
                                    <Stack direction={'row'} sx={{ gap: 1 }}>
                                        <div>{P_ProContent}</div>
                                        <div>{P_ProNum}/{P_SmallUnit}</div>
                                    </Stack>
                                </Stack>
                                <Stack sx={{ fontSize: 12 }} alignItems={'flex-end'}>

                                </Stack>
                                <Stack>
                                    <CButton onClick={() => addPro(data)}><AddIcon /></CButton>
                                </Stack>
                            </Stack>
                        )
                    })
                }
            </Stack>
            <Stack alignSelf={'center'}>
                {isSuccess && <Pagination onChange={(e, p) => setPage(p - 1)} count={Math.ceil(data.total / pagesize)} page={page + 1} />}
            </Stack>
        </Stack >
    )
}

export const ProTags = ({ price, P_IsShelves, P_TransportType, hzgm, hfgm, reservation, recommend }: any) => {
    // console.log(price)
    let _xrPrice = 0;
    let tags = []

    // shelves 上下架
    if (!P_IsShelves) tags.push(['已下架', 'bg-blue-100 text-blue-800 font-medium me-2 px-1.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300']);

    // transportType 运输模式
    if (P_TransportType == 2) tags.push(['冷链运输', 'bg-blue-100 text-blue-800 font-medium me-2 px-1.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300']);

    // hzgm 会诊购买
    if (hzgm) tags.push(['会诊购买', 'bg-pink-100 text-pink-800 font-medium me-2 px-1.5 py-0.5 rounded dark:bg-pink-900 dark:text-pink-300']);
    // hfgm 恢复购买
    else if (hfgm) tags.push(['恢复购买', 'bg-yellow-100 text-yellow-800 font-medium me-2 px-1.5 py-0.5 rounded dark:bg-yellow-900 dark:text-yellow-300']);
    // reservation 预订
    else if (reservation) tags.push(['预定购买', 'bg-red-100 text-red-800 font-medium me-2 px-1.5 py-0.5 rounded dark:bg-red-900 dark:text-red-300']);
    // recommend 推荐
    // else if (recommend) tags.push(['推荐', 'bg-green-100 text-green-800 font-medium me-2 px-1.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300']);
    else {
        _xrPrice = price;
    }

    // if (tags.length == 0) return null;
    return (<Stack sx={{ gap: 1 }} alignItems={'center'} direction={'row'}>
        <>{tags.map((tag) => <Stack sx={{ color: 'red', px: '3px', borderRadius: 1, border: '1px solid red' }}>{tag[0]}</Stack>)}</>
        <>{_xrPrice > 0 && <Stack sx={{ color: 'green' }}>¥{_xrPrice}</Stack>}</>
    </Stack>);
}

export default SortsDashboard;